/* eslint-disable no-unused-vars */
import { getStore } from "./services/store";
import { App } from "./services/action";
import { Auth } from "services/action";
import { Rest } from "./utilities/rest";
import Geocode from "react-geocode";

// const POD_URL = `${process.env.REACT_APP_POD_SYSTEM_URL}`;
// const TMS_URL = `${process.env.REACT_APP_TMS_SYSTEM_URL}`;

export default async function bootstrap() {
  const { dispatch, getState } = getStore();
  const session = getState().Auth;

  Geocode.setApiKey("AIzaSyCLxGBGLUUDJVq-7TpWuPAz72HjsPc3fOA");
  Geocode.setLanguage("id");
  Geocode.setLocationType("ROOFTOP");

  if (session.isAuthenticated) {
    // should read new profile
    const loggedin = await dispatch(Auth.$fetchProfile());
    if (!loggedin) {
      await dispatch(Auth.$logout());
    }
  }

  Rest.events.on("unauthorized", async (errors) => {
    await dispatch(Auth.$logout());
  });

  await dispatch(App.$appReady());
}
